import React from 'react';
import compose from 'lodash/fp/compose';
import withSellerReputation from '@catalogo/service-americanas-product/src/hocs/seller-reputation';
import { withSelectStore } from '@catalogo/service-americanas-product/src/hocs/select-store';
import { withMetrics } from '@catalogo/core-metrics';
import { Card } from './components/organisms/card';

export const SellerReputation = (props: any) => <Card {...props} />;

export default compose(withSelectStore, withSellerReputation, withMetrics)(SellerReputation);
